import { Link } from "react-router-dom";

interface TaxbyLogoProps {
  variant?: "light" | "dark";
  showTagline?: boolean;
  className?: string;
  asLink?: boolean;
}

const TaxbyLogo = ({
  variant = "dark",
  showTagline = false,
  className = "",
  asLink = true,
}: TaxbyLogoProps) => {
  const isLight = variant === "light";

  const content = (
    <div className={className}>
      <span
        className={`block text-2xl font-bold tracking-[0.12em] md:text-3xl ${
          isLight ? "text-white" : "text-gray-900"
        }`}
      >
        TAXBY
      </span>
      {showTagline && (
        <p
          className={`mt-1 text-sm font-normal tracking-normal ${
            isLight ? "text-white/85" : "text-gray-500"
          }`}
        >
          Contabilidad inteligente para autónomos
        </p>
      )}
    </div>
  );

  if (!asLink) return content;

  return (
    <Link to="/" className="inline-block transition-opacity hover:opacity-90">
      {content}
    </Link>
  );
};

export default TaxbyLogo;
